import { SundaeSDK } from "@sundaeswap/sdk-core";
import { Dispatch } from "react";

export enum EAppActions {
  /* -------------------------------------------------------------------------------------------------
   * App
   * -----------------------------------------------------------------------------------------------*/
  CONNECT_WALLET_OPEN = "CONNECT_WALLET_OPEN",
  SET_SDK = "SET_SDK",
  SET_CONNECTED_WALLET = "SET_CONNECTED_WALLET",
  SET_ERROR_REPORTING = "SET_ERROR_REPORTING",
  SET_OFFCANVAS_OPEN = "SET_OFFCANVAS_OPEN",
  SET_POOLS_SORTING_DIRECTION = "SET_POOLS_SORTING_DIRECTION",
  SET_POOLS_SORT_BY = "SET_POOLS_SORT_BY",
  SET_CHOOSE_HANDLE_OPEN = "SET_CHOOSE_HANDLE_OPEN",
  SET_CHOOSE_AVATAR_OPEN = "SET_CHOOSE_AVATAR_OPEN",
  SET_WRONG_NETWORK_OPEN = "SET_WRONG_NETWORK_OPEN",
  SET_ZAP_OPEN = "SET_ZAP_OPEN",
  SET_EXCHANGE_WIDGET_NAVIGATION_FROM = "SET_EXCHANGE_WIDGET_NAVIGATION_FROM",
}

export interface IAppAction {
  type: string;
  // Payload types are inforced in ./actions
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload?: any;
}

export enum ExchangeMode {
  buy = "buy",
  sell = "sell",
  swap = "swap",
  create = "create",
}

export enum ExchangeOrderType {
  market = "market",
  limit = "limit",
  default = "market",
}

export enum EPoolTableSortingOptions {
  apy = "apy",
  change24 = "change24",
  fees24 = "fees24",
  price = "price",
  totalValueLocked = "totalValueLocked",
  volume24 = "volume24",
  poolName = "poolName",
}

export enum ESortingDirection {
  asc = "asc",
  desc = "desc",
}

export interface IAppState {
  sdk: SundaeSDK;
  chooseHandleOpen: boolean;
  chooseAvatarOpen: boolean;
  offCanvasOpen: boolean;
  sortPoolsSortingDirection: ESortingDirection;
  sortPoolsBy: EPoolTableSortingOptions;
  walletConnectOpen: boolean;
  wrongNetworkOpen: boolean;
  zapOpen: boolean;
}

export interface IAppContext {
  state: IAppState;
  dispatch: Dispatch<IAppAction>;
}
